import { Injectable } from '@angular/core';

/**
 * Hand-off point for the email thread of the ticket currently being opened.
 *
 * {@link HelpDeskComponent} writes the thread here after fetching ticket details,
 * and {@link MessageStackComponent} reads it back during `ngOnInit`. A plain
 * mutable property is enough because the value is always assigned before the
 * consuming component is created.
 */
@Injectable({
  providedIn: 'root'
})
export class MessageStackService {
  /** Email thread for the open ticket, as returned by `TicketService.getTicketDetails`. */
  messageStack! :any;

  /**
   * Ticket the thread in {@link messageStack} belongs to. Written alongside it so
   * a consumer can tell a fresh hand-off from a thread left behind by an earlier
   * ticket, which history traversal can otherwise present as the current one.
   */
  ticketId?: string;

  constructor() { }
}
